function fireFacebookPageView(){
  const id = this.getOcodeValue('component.PartialPageViewPixel.facebookTrackingId')
  const fbScript = this.doc.createElement('script');
  fbScript.setAttribute('type', 'text/javascript');
  fbScript.innerHTML = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '${id}');
    fbq('track', 'PageView');
  `;
  this.doc.body.appendChild(fbScript);
}

function fireFacebookConversion() {
  const overridePrefix = this.getOverridePrefix();
  const id = this.getOcodeValue(`${overridePrefix}.facebookTrackingId`);
  const eventType = this.getOcodeValue(`${overridePrefix}.facebookEventType`) || 'Lead';
  if (typeof this.win.fbq === 'function') {
      this.win.fbq('trackSingle', id, eventType);
  }
}

module.exports = {
  fireFacebookPageView,
  fireFacebookConversion,
};
